import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import { ORGANISATION_ROLES_RESOURCE } from '../constants';
import apiRoutes from '../../../app/api/routes';

const OrganisationRolesService = ComposedComponent =>
  reduxFetch([
    {
      resource: ORGANISATION_ROLES_RESOURCE,
      method: 'get',
      request: (rejectCallback, t) => ({
        url: apiRoutes.organisationRoles(),
        meta: {
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getOrganisationRolesFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default OrganisationRolesService;
